import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const PinterestOutlined32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.pinterestFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm0 1.5c-7.119 0-12.9 5.781-12.9 12.9 0 7.119 5.781 12.9 12.9 12.9 7.119 0 12.9-5.781 12.9-12.9 0-7.119-5.781-12.9-12.9-12.9zm-3.117 7.055s2.49-1.801 5.884-.557c0 0 3.095 1.025 3.368 4.635.279 3.61-1.88 5.363-1.88 5.363s-1.897 1.831-4.082.868c0 0-.591-.215-.994-.887l-.688 2.772s-.298 1.126-1.528 2.746c0 0-.118.147-.217 0 0 0-.111-.692-.133-1.38-.022-.688-.022-1.354.242-2.518l1.06-4.628.012-.01c-.121-.192-.412-.787-.248-2.016 0 0 .198-1.447 1.208-1.735 1.01-.288 1.602.301 1.655 1.156.053.857-.505 2.378-.505 2.378l-.204.736-.093.384s-.245 1.104.87 1.59c0 0 .967.439 1.987-.525 0 0 .814-.832 1.143-2.195 0 0 .877-3.159-.778-4.64-1.655-1.482-3.935-.884-4.685-.506-.75.384-2.256 1.418-2.386 3.917 0 0-.034.954.48 1.715l.192.237s.109.125.081.244l-.23.937s-.092.301-.374.211c0 0-1.438-.361-1.807-2.576 0 0-.765-3.472 2.65-5.716z"
      fillRule="evenodd"
    />
  </svg>
);

export default PinterestOutlined32;
